"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var React = require('react');

var PropTypes = require('prop-types');

var moment = require('moment');

var uniq = require('lodash/uniq');

var _require = require('react-dom/server'),
    renderToStaticMarkup = _require.renderToStaticMarkup;

function List(_ref) {
  var data = _ref.data,
      label = _ref.label;
  var list_content = Object.keys(data).map(function (key) {
    var value = data[key];

    if (_typeof(value) === 'object') {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: key + 'A'
      }, /*#__PURE__*/React.createElement("li", null, key), /*#__PURE__*/React.createElement(List, {
        data: value
      }));
    }

    return /*#__PURE__*/React.createElement("li", {
      key: key
    }, key, ": ", /*#__PURE__*/React.createElement("strong", null, value));
  });

  if (label) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, label), list_content.length ? /*#__PURE__*/React.createElement("ul", {
      key: label
    }, list_content) : /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "None")));
  }

  return /*#__PURE__*/React.createElement("ul", null, list_content);
}

List.propTypes = {
  data: PropTypes.object.isRequired,
  label: PropTypes.string
};

function sum(arr, key) {
  return arr.map(function (obj) {
    return obj[key];
  }).reduce(function (p, v) {
    return p + v;
  }, 0);
}

function formatData(arr) {
  var keys = uniq(arr.map(function (_ref2) {
    var key = _ref2.key;
    return key;
  }));
  var data = {};
  keys.forEach(function (key) {
    var matching = arr.filter(function (obj) {
      return obj.key === key;
    });
    var name = matching[0].name;
    var total = sum(matching, 'quantity');
    data[name] = total;
  });
  return data;
}

function InventoryReport(_ref3) {
  var inventory = _ref3.inventory,
      dates = _ref3.dates,
      estimatedDigitalPrintingCost = _ref3.estimatedDigitalPrintingCost,
      estimatedLetterpressPrintingCost = _ref3.estimatedLetterpressPrintingCost;
  var wax_seals = inventory.filter(function (_ref4) {
    var category = _ref4.category;
    return category === 'wax_seals';
  });
  var ribbon_spools = inventory.filter(function (_ref5) {
    var category = _ref5.category;
    return category === 'ribbon_spools';
  });
  var paper = inventory.filter(function (_ref6) {
    var category = _ref6.category;
    return category === 'paper';
  });
  var lp_paper = inventory.filter(function (_ref7) {
    var category = _ref7.category;
    return category === 'letterpress_paper';
  });
  var envelopes = inventory.filter(function (_ref8) {
    var category = _ref8.category;
    return category === 'envelopes';
  });
  var vellum_jackets = inventory.filter(function (_ref9) {
    var category = _ref9.category;
    return category === 'vellum_jackets';
  });
  var glue_dots = inventory.filter(function (_ref10) {
    var category = _ref10.category;
    return category === 'glue_dots';
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Shine Inventory"), /*#__PURE__*/React.createElement("p", null, "Starting ", moment(dates[0]).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement("p", null, "Ending ", moment(dates[1]).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement("p", null, "Weekly Digital Estimated Printing Cost: $", estimatedDigitalPrintingCost.toFixed(2)), /*#__PURE__*/React.createElement("p", null, "Weekly Letterpress Estimated Printing Cost: $", estimatedLetterpressPrintingCost.toFixed(2)), /*#__PURE__*/React.createElement("p", null, "Vellum Jackets: ", /*#__PURE__*/React.createElement("strong", null, sum(vellum_jackets, 'quantity'))), /*#__PURE__*/React.createElement("p", null, "Glue Dots: ", /*#__PURE__*/React.createElement("strong", null, sum(glue_dots, 'quantity'))), /*#__PURE__*/React.createElement(List, {
    key: "Wax Seals",
    label: "Wax Seals",
    data: formatData(wax_seals)
  }), /*#__PURE__*/React.createElement(List, {
    key: "Ribbon Spools",
    label: "Ribbon Spools",
    data: formatData(ribbon_spools)
  }), /*#__PURE__*/React.createElement(List, {
    key: "Envelopes",
    label: "Envelopes",
    data: formatData(envelopes)
  }), /*#__PURE__*/React.createElement(List, {
    key: "Paper",
    label: "Paper",
    data: formatData(paper)
  }), /*#__PURE__*/React.createElement(List, {
    key: "Letterpress Paper",
    label: "Letterpress Paper",
    data: formatData(lp_paper)
  }));
}

InventoryReport.propTypes = {
  inventory: PropTypes.array.isRequired,
  estimatedDigitalPrintingCost: PropTypes.number.isRequired,
  estimatedLetterpressPrintingCost: PropTypes.number.isRequired,
  dates: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.instanceOf(moment)])).isRequired
};

function generateInventoryReport(inventory, fromDate, toDate) {
  var estimatedDigitalPrintingCost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var estimatedLetterpressPrintingCost = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  return renderToStaticMarkup( /*#__PURE__*/React.createElement(InventoryReport, {
    inventory: inventory,
    dates: [fromDate, toDate],
    estimatedDigitalPrintingCost: estimatedDigitalPrintingCost,
    estimatedLetterpressPrintingCost: estimatedLetterpressPrintingCost
  }));
}

module.exports = generateInventoryReport;